<template>
  <div id="navigation">
    <img class="image" src="../assets/logoalt.png">
    <div class="text">
      <a class="title" href="./index.html">Annamaria <span class="lastName">Koshy</span></a>
      <div class="icons"><a href="mailto:someone@yoursite.com" class="fas fa-envelope"></a><a href="https://www.linkedin.com/in/annamaria-koshy-a2a167149/" target="_blank" class="fab fa-linkedin"></a><a href="https://annamariakoshy.itch.io/" class="fab fa-itch-io" target="_blank"></a><a href="https://twitter.com/AnnamariaKoshy" target="_blank" class="fab fa-twitter-square"></a></div>
      <div class="pages">
        <router-link to="/">Portfolio</router-link>
        <div id="sortbutton" class="sortbutton hide"><div class="button-group filters-button-group">
          <button class="button is-checked" data-filter="*">show all</button>
          <button class="button" data-filter=".games">game design</button>
          <button class="button" data-filter=".writing">writing</button>
          <button class="button" data-filter=".art">graphic design</button>
          <button class="button" data-filter=".film">films</button>
        </div></div>
        <router-link to="/resume">Resume</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'navigation'
}
</script>

<style scoped>

.lastName{
  font-size:2.2em;
}
.sortbutton {
  display:flex;
}

.hide {
  display:none !important;
}

.text{

  padding-bottom:1em;
}

#navigation{
  border-right:5px solid var(--primarylight);
  flex: 0 0 170px;
  padding:0px 2em;
}

.fas, .fab {
  display:inline!important;
  margin-right:10px;
}

.fas:hover, .fab:hover {
  color:var(--primarylight) !important;
  cursor:pointer;
}

.icons{
  margin-top:10px;
  font-size:18px;
}

#navigation img{
  display:block;
  width:150px;
  margin:0 auto;
  margin-top:50px;
  margin-bottom:20px;}

.pages{
  letter-spacing: .1em;
  margin-top:20px;
}

.pages a{
  margin-top:5px;
}

#navigation .icons img{
  width:20px;

}

/* ---- button ---- */

.button{
  display:block;
  border:none;
  margin-right:10px;
  border-radius:0.12em;
  box-sizing: border-box;
  text-decoration:none;
  font-weight:300;
  color:var(--second);
  text-align:center;
  transition: all 0.2s;
  background-color:#00000000;
  font-family: 'Alata', sans-serif;
  font-weight:700;
  padding:4px 8px;
  margin:5px 0px;
  font-size:12px;
}
button:hover{
  cursor:pointer;
  background-color:var(--secondlight);
  letter-spacing: .1em;
  color: var(--second)
}

.button:active,
.button.is-checked {
  color:var(--primarylight);
  text-transform: uppercase;
  letter-spacing:0.1em;
}


button:focus { outline:0 !important; }


/* ---- button-group ---- */

.button-group{
  padding-top:5px;
  padding-bottom:5px;
  padding-left:15px;
}

.button-group:after {
  content: '';
  display: block;
  clear: both;
}
</style>